import { render, staticRenderFns } from "./BaseAuthenticationWrapper.vue?vue&type=template&id=5efac5d7&"
import script from "./BaseAuthenticationWrapper.vue?vue&type=script&lang=js&"
export * from "./BaseAuthenticationWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports